import { createAjv } from '@takeshape/json-schema';
import cloneDeep from 'lodash/cloneDeep.js';
const ajv = createAjv();
export const baseServiceConfigSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        provider: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        serviceType: {
            type: 'string'
        },
        authenticationType: {
            type: 'string'
        }
    },
    required: ['id', 'provider', 'title', 'serviceType', 'authenticationType'],
    /**
     * Some code paths introduce extra values that can throw off validations,
     * so it's wise to keep this set to true.
     */
    additionalProperties: true
};
export class BaseServiceProvider {
    name;
    title;
    description;
    categories;
    links;
    formConfig;
    formSchema;
    validateServiceConfig;
    constructor({ name, title, description, categories, links, formConfig, formSchema, serviceConfigSchema }) {
        this.name = name;
        this.title = title;
        this.description = description;
        this.categories = categories;
        this.links = links;
        this.formConfig = formConfig;
        this.formSchema = formSchema;
        this.validateServiceConfig = this.createServiceConfigValidator(serviceConfigSchema);
    }
    createId(_options) {
        return this.name;
    }
    /**
     * Should return true for complete configs that have no `authentication`, encrypted or
     * decrypted `authentication`. Does not validate `authentication`.
     */
    isCompleteConfig(serviceConfig) {
        return this.validateServiceConfig(serviceConfig);
    }
    getFormSchema() {
        return this.formSchema;
    }
    getFormConfig() {
        return this.formConfig;
    }
    getConfig(formData) {
        return formData;
    }
    isServiceConfig(serviceConfig) {
        return this.validateServiceConfig({
            ...serviceConfig,
            __encryptionStatus: 'decrypted'
        });
    }
    createValidator(schema) {
        return ajv.compile(schema);
    }
    /**
     * If a ServiceConfigSchema contains a validation for `authentication` change it to a
     * provide a discriminated union for the encrypted string-form.
     */
    createServiceConfigValidator(schema) {
        const validatorSchema = cloneDeep(schema);
        if (validatorSchema.properties && 'authentication' in validatorSchema.properties) {
            const authentication = validatorSchema.properties.authentication;
            authentication.type = Array.isArray(authentication.type)
                ? [...authentication.type, 'string']
                : authentication.type
                    ? [authentication.type, 'string']
                    : ['string'];
        }
        return ajv.compile(validatorSchema);
    }
    extend(props) {
        Object.assign(this, props);
        return this;
    }
}
